import axios from "axios";
import { EstadoLoginStudent, FlagsSesion } from "../types";
import { axiosInstances } from "../components/AxiosManager/AxiosInstances";

export interface LoginResponse {
  data: EstadoLoginStudent;
  status: number;
}
/**
 * Retorna idPersona y idAP de la persona autenticada - token con idAP
 * @param email 
 * @returns { data: EstadoLoginStudent, status: number }
 */
export const login = async (email: string): Promise<LoginResponse> => {
  try {
    const { data, status } = await axiosInstances.login.post("/doLogin", { email: email });
    return { data, status };
  } catch (error) {
    return {
      data: {
        bloqueado: false,
        cantidadCarreras: 0,
        carreras: [],
        debeElegirCarrera: false,
        inicializando: false,
        mensajeBloqueo: "",
        mensajePrioridad: "",
        contactoBloqueo: "",
        mostrarHorarios: false,
        prioridad: false,
        debeAlertarSuperposicion: false,
        filtrarCursosConCupoNoAsignado: false,
        token: "",
        error: error || "An error occurred during login",
      },
      status: 500,
    };
  }
};

function isFlagsSesion(value: unknown): value is FlagsSesion {
  if (!value || typeof value !== "object") return false;
  const flags = value as FlagsSesion;
  return (
    typeof flags.mostrarAulas === "boolean" &&
    typeof flags.debeAlertarSuperposicion === "boolean" &&
    typeof flags.filtrarCursosConCupoNoAsignado === "boolean"
  );
}

/**
 * Flags que pueden cambiar sin un login nuevo. Se consultan al recargar la app,
 * cuando la sesión se rehidrata desde el snapshot y no se vuelve a llamar a /doLogin.
 */
export const getFlagsSesion = async (): Promise<FlagsSesion | null> => {
  try {
    const { data } = await axiosInstances.login.post("/api/flagsSesion", {});
    return isFlagsSesion(data) ? data : null;
  } catch (error) {
    console.error("Error al actualizar los flags de sesión", error);
    return null;
  }
};

export const getEstadoAlumno = async () => {
  try {
    const { data } = await axiosInstances.login.post(`/api/estadoAlumno?r=${Math.random().toString()}`, {});
    return data;
  } catch (error) {
    return { error };
  }
};

export const postSeleccionaCarrera = async (idAlumnoPrograma: number) => {
  try {
    const { data } = await axiosInstances.login.post(`/api/elegirCarrera`, { idAlumnoPrograma });
    return data;
  } catch (error) {
    return { error };
  }
};

/**
 * Retorna idPersona y email de la persona autenticada - token sin idAP
 * @returns 
 */
export const auth = async () => {
  try {
    const { data, status } = await axiosInstances.login.get("/auth");
    return data;
  } catch (error) {
    return { error };
  }
};

export const doCampusAuth = async (token: string): Promise<{ data: EstadoLoginStudent, status: number }> => {
  try {
    const { data, status } = await axiosInstances.login.post('/doCampusLogin', { campusToken: token });
    return { data, status };
  } catch (error) {
    return {
      data: {
        bloqueado: false,
        cantidadCarreras: 0,
        carreras: [],
        debeElegirCarrera: false,
        inicializando: false,
        mensajeBloqueo: "",
        mensajePrioridad: "",
        contactoBloqueo: "",
        mostrarHorarios: false,
        prioridad: false,
        debeAlertarSuperposicion: false,
        filtrarCursosConCupoNoAsignado: false,
        token: "",
        error: error || "An error occurred during login",
      },
      status: 500,
    };
  }
};

export const verifyTurnstile = async (token: string) => {
  try {
    const { data } = await axiosInstances.login.post('/verifyTurnstile', { 'cf-turnstile-response': token });
    return data;
  } catch (error) {
    return { error };
  }
};
